module.exports = __webpack_public_path__ + "img/Feature.1423cac7.jpg";